import { memoize } from 'lodash';

const CURRENCY_SYMBOL = new Map([['USD', 'en-US'], ['EUR', 'de-DE']]);

const resolveFormatter = memoize(
    (locale, currency) => {
        if (CURRENCY_SYMBOL.has(currency)) {
            locale = CURRENCY_SYMBOL.get(currency);
        }

        return new Intl.NumberFormat(locale, {
            style: 'currency',
            currency: currency,
            currencyDisplay: CURRENCY_SYMBOL.has(currency) ? 'symbol' : 'code',
            minimumFractionDigits: 0,
            useGrouping: false,
        });
    },
    (l, c) => `${l}${c}`
);

const formatPrice = (amount, currency, locale) => {
    return resolveFormatter(locale, currency).format(amount);
};

export default formatPrice;
